import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_OBSERVATIONS_ACTIVITIES_REQUEST,
    FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS,
    FETCH_OBSERVATIONS_ACTIVITIES_FAILURE,
} from '../actions/dataActions';
import { getActivityObservations, getActivityObservationById, deleteActivityObservation } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';
import {
    FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST,
    FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS,
    FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE,
    DELETE_ACTIVITY_OBSERVATION_REQUEST,
    DELETE_ACTIVITY_OBSERVATION_SUCCESS,
    DELETE_ACTIVITY_OBSERVATION_FAILURE,
} from '../actions/dataActions';

/**
 * Saga pour récupérer les observations d'activités
 */
function* fetchObservationsActivitiesSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getActivityObservations, params);
        yield put({ type: FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des observations d\'activités');
        yield put({ type: FETCH_OBSERVATIONS_ACTIVITIES_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour récupérer une observation d'activité par ID
 */
function* fetchActivityObservationByIdSaga(action) {
    try {
        const observationId = action.payload;
        const data = yield call(getActivityObservationById, observationId);
        yield put({ type: FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de l\'observation d\'activité');
        yield put({ type: FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE, payload: errorMessage });
    }
}

/**
 * Saga pour supprimer une observation d'activité
 */
function* deleteActivityObservationSaga(action) {
    try {
        const observationId = action.payload;
        const data = yield call(deleteActivityObservation, observationId);
        yield put({ type: DELETE_ACTIVITY_OBSERVATION_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression de l\'observation d\'activité');
        yield put({ type: DELETE_ACTIVITY_OBSERVATION_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions d'observations d'activités
 */
export function* watchObservationsRequests() {
    yield takeEvery(FETCH_OBSERVATIONS_ACTIVITIES_REQUEST, fetchObservationsActivitiesSaga);
    yield takeEvery(FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST, fetchActivityObservationByIdSaga);
    yield takeEvery(DELETE_ACTIVITY_OBSERVATION_REQUEST, deleteActivityObservationSaga);
}

// Alias pour compatibilité avec l'ancien code
export function* watchActivitiesRequests() {
    yield takeEvery(FETCH_OBSERVATIONS_ACTIVITIES_REQUEST, fetchObservationsActivitiesSaga);
    yield takeEvery(FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST, fetchActivityObservationByIdSaga);
    yield takeEvery(DELETE_ACTIVITY_OBSERVATION_REQUEST, deleteActivityObservationSaga);
}




